import {
    SegmentEntityType,
    ViewRow,
    WpDisplayConfig,
    WpViewTable,
} from '../../core';

export function determineRowLabel(
    r: ViewRow,
    table: WpViewTable,
    config: WpDisplayConfig,
): string {
    const drillPath = config.drillPaths.find(
        (e) => e.identifier === table.drillPathIdentifier,
    );
    const segment = drillPath?.segments?.find(
        (e) => e.identifier === r.segmentIdentifier,
    );

    let label: string | null = null;
    switch (segment.entityType) {
        case SegmentEntityType.USER:
            label = `${r.user?.firstName?.trim() ?? ''} ${
                r.user?.lastName?.trim() ?? ''
            }`;
            break;
        case SegmentEntityType.METRIC:
            label = r.metric?.fullName?.trim();
            break;
        case SegmentEntityType.BEHAVIOUR:
            label = r.behaviour?.name?.trim();
            break;
        case SegmentEntityType.SUB_BEHAVIOUR:
            label = r.subBehaviour?.name?.trim();
            break;
    }
    return label;
}
